//import "es6-promise/auto";
import App from './src/App.vue';
import FilterableList from '../../filterable-list/app/src/FilterableList.vue';
import FilterNewsroomEvent from '../../filter-newsroom-event/app/src/FilterNewsroomEvent.vue';

// State Management
import store from './src/store';

const { createApp }  = Vue;



(function(window) {
	let _init = ({ config = {}, container = '' }) => {
		const appContainer = document.getElementById(container);
		console.info(`Newsroom version 3 prod`);

		if (appContainer) {
			console.log('LmuNewsroom Initialised');
			const app = createApp({});
			app.use(store(config));
			app.component('newsroom-app', App);
			app.component('filterable-list', FilterableList);
			app.component('filter-newsroom-event', FilterNewsroomEvent);
			app.mount(appContainer);
		} else {
			console.error('LmuNewsroom Initialised failed!');
		}
	};

	window.LmuNewsroom = {
		init: _init
	};
})(window);


